import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import FormHospital from '../../../../components/user/FormHospital'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class FormCreate extends Component {
	state = {
        listFamily:[],
        detailProfile:[]
	}

    fetchMedicalExpensesLicensee = async () =>{
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchMedicalExpensesLicensee,
        })

        // console.log('data',data)
        if(data.fetchMedicalExpensesLicensee){
            let dataEdit = []

            data.fetchMedicalExpensesLicensee.map((values, keys)=>{
                if(values.relationship != '00'){
                    dataEdit.push(values)
                }
            })

            await this.setState({
                listFamily: dataEdit
            })
        }
    }

    fetchProfile = async () => {
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchProfile,
        })
        // console.log()
        await this.setState({
            detailProfile: data.fetchProfile
        })
    }

	onSubmit = async (values) => {
        const { form, afterSubmit, client } = this.props
        const { telNo, otpToken, refCode } = this.state
        window.location.href = '/hospital/Withdraw/'

		// form.validateFields(async (err, values) => {
		// 	if (!err) {
        //         try {
                    
        //             const { data, errors } = await client.mutate({
        //                 mutation: Mutations.changePhoneNumber,
        //                 variables: {
        //                     telNo,
        //                     otp:{
        //                         otpToken: otpToken,
        //                         refCode: refCode,
        //                         otpCode: values.otp
        //                     }
        //                 }
        //             })

        //             console.log(data)

        //             if(data){
        //                 message.success("ส่งเพื่อดำเนินการเรียบร้อย")
        //                 setTimeout(() => {
        //                     window.location.reload();
        //                 }, 600);
        //             }
        //         }catch (error) {
                    
        //         }
		// 	}
		// })
	}

    
	async componentDidMount(){
        await this.fetchMedicalExpensesLicensee()
        await this.fetchProfile()
        // const { match, location } = this.props
        // if(location.pathname.split('/')[3]){
        //     this.fetchData();
        // }
        // console.log(location.pathname.split('/')[3])
    }

	render() {
		const { match, location } = this.props
		const { detailProfile, listFamily } = this.state

        // console.log(dataForm)
		return (
			<Container match={match}>
                <div className="breadcrumb-custom pb-3 mb-5">
                    {/* <Breadcrumb.Item> */}
                        <span style={{ fontSize:"18px" }}>การเบิกค่ารักษาพยาบาล / ผู้มีสิทธิเบิกค่ารักษาพยาบาล</span>
                    {/* </Breadcrumb.Item> */}
                </div>
				<FormHospital autoFocus afterSubmit={this.onSubmit} listFamily={listFamily} detailProfile={detailProfile}/>
			</Container>
		)
	}
}

FormCreate.defaultProps = {
	autoFocus: false
}

FormCreate.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedFormCreate = Form.create()(FormCreate)

export default withApollo(WrappedFormCreate)